import { useHistory } from "react-router-dom";
import { EngagementStatus } from "@wingspanhq/payments/dist/interfaces";

export const ENGAGEMENT_TYPES_ROOT_PATH = "/member/engagement-types";

export const ENGAGEMENT_TYPES_TAB_SLUGS = ["active", "archived"] as const;

export const ENGAGEMENT_TYPES_SECTION_PATHS = ENGAGEMENT_TYPES_TAB_SLUGS.map(
  tabSlug => `${ENGAGEMENT_TYPES_ROOT_PATH}/${tabSlug}`
);

export const ENGAGEMENT_TYPES_DETAILS_PATH = `${ENGAGEMENT_TYPES_ROOT_PATH}/:engagementTypeId`;

type TabSlug = (typeof ENGAGEMENT_TYPES_TAB_SLUGS)[number];

export const getSectionPathByEngagementStatus = (
  engagementTypeStatus: EngagementStatus
) => {
  const mapping: Record<EngagementStatus, TabSlug> = {
    [EngagementStatus.Active]: "active",
    [EngagementStatus.Inactive]: "archived"
  };

  const slug = mapping[engagementTypeStatus] || "active";

  return `${ENGAGEMENT_TYPES_ROOT_PATH}/${slug}`;
};

export const buildEngagementTypeDetailsURL = (engagementTypeId: string) => {
  return ENGAGEMENT_TYPES_DETAILS_PATH.replace(
    ":engagementTypeId",
    engagementTypeId
  );
};

export const useGoToEngagementTypes = () => {
  const history = useHistory();
  return (engagementTypeStatus?: EngagementStatus) => {
    history.push(
      getSectionPathByEngagementStatus(
        engagementTypeStatus || EngagementStatus.Active
      )
    );
  };
};

export const useGoToEngagementTypeDetails = () => {
  const history = useHistory();
  return (engagementTypeId: string) => {
    history.push(buildEngagementTypeDetailsURL(engagementTypeId));
  };
};
